var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgQuotes = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.214 25C27.752 25 29 23.8 29 22.321V15.18c0-1.48-1.248-2.679-2.786-2.679h-4.643V8.929c0-1.97 1.666-3.572 3.715-3.572h.464c.772 0 1.393-.597 1.393-1.34V1.34C27.143.597 26.522 0 25.75 0h-.464C20.156 0 16 3.996 16 8.929V22.32C16 23.801 17.248 25 18.786 25h7.428zm-16 0C11.752 25 13 23.8 13 22.321V15.18c0-1.48-1.248-2.679-2.786-2.679H5.571V8.929c0-1.97 1.666-3.572 3.715-3.572h.464c.772 0 1.393-.597 1.393-1.34V1.34C11.143.597 10.522 0 9.75 0h-.464C4.156 0 0 3.996 0 8.929V22.32C0 23.801 1.248 25 2.786 25h7.428z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuotes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quotes.927bb55c.svg";
export { ForwardRef as ReactComponent };